import { createKey } from './createKey';
import { OrderClassificationSearchRequest } from '@trukt/tms-api/OrderClassificationService';

const keyHandler = createKey('order-classification');

export const OrderClassificationServiceKeys = {
  key: keyHandler.key,
  search: keyHandler.createMethod<OrderClassificationSearchRequest>(),
};
